import * as React from 'react';
import { DealerSvc } from '../../../../shared/services/dealer-service';
import { DealerSales } from '../../../../support/models/dealers/dealer-sales';
import { StatusCode } from '../../../../utils/api';
import { DealerSalesView } from './DealerSalesView';

interface IProps {
    dealerId: string;
}

/** Gets the sales of a dealer and shows them. */
export const DealerSalesTable = (props: IProps) => {

    const [service] = React.useState(new DealerSvc());
    const [sales, setSales] = React.useState<DealerSales | undefined>(undefined);

    React.useEffect(() => {
        let current = true;

        (async () => {
            const result = await service.getSales(props.dealerId);
            if (current && result.status === StatusCode.Success) {
                setSales(result.data);
            }
        })();

        return () => { current = false; };
    }, [props.dealerId]);

    return <DealerSalesView sales={sales} />;

};
